import SimpleBannerRepository from "../SimpleBannerRepository"

export default class ResourcesInPageBanner extends SimpleBannerRepository {
    static schemaId = "resource_banner"

    constructor() {
        super(ResourcesInPageBanner.schemaId)
    }
}
